import _extends from "@babel/runtime/helpers/extends";
import { COLOR } from "@xe/constants";
import { buttons, fluidContainers, guilloches, icons, links, listItems, paragraphs } from "@xe/theme-config-common";
var heading = {
  color: COLOR.blue2
};
export default _extends({}, buttons.lightMode, fluidContainers.light1, guilloches.light1, icons.lightMode, links.lightMode, listItems.lightMode, paragraphs.lightMode, {
  heading: heading
});